import { useAppSelector } from '@/store/hooks'
import { getProfileInfo } from '@/store/selectors/profileSelector'
import { Dictionary } from '@/types/field'
import { BadgeDollarSign, Calendar, House, Image, Settings, UsersRound, UserX } from 'lucide-react'
import { useMatch } from 'react-router-dom'

const SidebarData = () => {
    const { user } = useAppSelector((state: Dictionary) => getProfileInfo(state))
    const data = {
        user: {
            fname: user.name,
            email: user.email,
            avatar: '/avatars/shadcn.jpg'
        },
        navSuperAdmin: [
            {
                label: '',
                items: [
                    {
                        title: 'Dashboard',
                        url: '/',
                        isActive: Boolean(useMatch('/')),
                        icon: House
                    },
                    {
                        title: 'Users',
                        url: 'user',
                        isActive: Boolean(useMatch('/user/*')),
                        icon: UsersRound
                    },
                    {
                        title: 'Analysis',
                        url: 'analysis-history',
                        isActive: Boolean(useMatch('/analysis-history/*')),
                        icon: Image
                    },
                    {
                        title: 'Transactions',
                        url: 'transactions',
                        isActive: Boolean(useMatch('/transactions')),
                        icon: BadgeDollarSign
                    },
                    {
                        title: 'Subscription',
                        url: 'subscription',
                        isActive: Boolean(useMatch('/subscription/*')),
                        icon: Calendar
                    },
                    {
                        title: 'Self Exclusion',
                        url: 'self-exclusion',
                        isActive: Boolean(useMatch('/self-exclusion')),
                        icon: UserX
                    },
                    {
                        title: 'Settings',
                        url: 'settings',
                        isActive: Boolean(useMatch('/settings')),
                        icon: Settings
                    }
                ]
            }
        ]
    }
    return data
}

export default SidebarData
